import React, { useMemo } from 'react';
import DecisionEngineBlock from '../../decision-engine/DecisionEngineBlock';
import DrawerFooterActions from './DrawerFooterActions';

function Row({ label, value }) {
  return (
    <li className="flex items-center justify-between text-sm">
      <span className="text-slate-500 dark:text-slate-400">{label}</span>
      <span className="font-black text-slate-900 dark:text-white">{value}</span>
    </li>
  );
}

export default function SessionDetailDrawer({ entity, onClose }) {
  const payload = entity?.payload || {};
  const sessionBehavior = Array.isArray(payload?.sessionBehavior) ? payload.sessionBehavior : [];

  const summary = useMemo(() => {
    const sample = sessionBehavior.reduce((sum, row) => sum + Number(row?.sampleSize || 0), 0);
    const anomalies = [];
    const acceptNoSample = sessionBehavior.filter((row) => Number(row?.sampleSize || 0) === 0 && Number(row?.metrics?.acceptRate?.value || 0) > 0);
    if (acceptNoSample.length > 0) {
      anomalies.push('Örneklem 0 iken kabul oranı görünen oturumlar var; event sözleşmesi kontrol edilmeli.');
    }
    const highAcceptLowCook = sessionBehavior.filter(
      (row) => Number(row?.metrics?.acceptRate?.value || 0) >= 50 && Number(row?.metrics?.cookRate?.value || 0) < 20
    );
    const priority = highAcceptLowCook.length >= 5 ? 'HIGH' : highAcceptLowCook.length >= 2 ? 'MEDIUM' : 'LOW';
    const confidence = sample >= 100 ? 'YÜKSEK' : sample >= 20 ? 'ORTA' : 'DÜŞÜK';
    return { sample, anomalies, highAcceptLowCook, priority, confidence };
  }, [sessionBehavior]);

  const handleExport = () => {
    const blob = new Blob([JSON.stringify(payload, null, 2)], { type: 'application/json;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `session-davranis-detay-${Date.now()}.json`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
  };

  return (
    <div className="space-y-4">
      <section className="rounded-lg border border-slate-200 bg-slate-50 p-3 dark:border-slate-800 dark:bg-slate-900">
        <p className="text-xs text-slate-500 dark:text-slate-400">Session Summary Hero</p>
        <h4 className="mt-1 text-lg font-black text-slate-900 dark:text-white">{sessionBehavior.length.toLocaleString('tr-TR')}</h4>
        <p className="text-sm text-slate-600 dark:text-slate-300">Oturum sayısı | Örneklem: {summary.sample.toLocaleString('tr-TR')}</p>
      </section>

      <section className="rounded-lg border border-slate-200 bg-white p-3 dark:border-slate-800 dark:bg-slate-900/60">
        <p className="text-xs font-semibold text-slate-500 dark:text-slate-400">İlk Oturumlar</p>
        {sessionBehavior.length === 0 ? (
          <p className="mt-2 text-sm text-slate-500 dark:text-slate-400">Bu filtrede session verisi bulunmuyor.</p>
        ) : (
          <ul className="mt-2 space-y-2">
            {sessionBehavior.slice(0, 15).map((row) => (
              <li key={row.sessionKey} className="rounded-md border border-slate-200 bg-slate-50 px-2 py-2 dark:border-slate-700 dark:bg-slate-800">
                <p className="text-xs font-semibold text-slate-700 dark:text-slate-200">{String(row.sessionKey || '').slice(0, 24)}</p>
                <ul className="mt-1 space-y-1">
                  <Row label="Kabul" value={`%${Number(row?.metrics?.acceptRate?.value || 0).toLocaleString('tr-TR')}`} />
                  <Row label="Wow" value={`%${Number(row?.metrics?.wowRate?.value || 0).toLocaleString('tr-TR')}`} />
                  <Row label="Pişirme" value={`%${Number(row?.metrics?.cookRate?.value || 0).toLocaleString('tr-TR')}`} />
                </ul>
              </li>
            ))}
          </ul>
        )}
      </section>

      <DecisionEngineBlock
        narrative="Session katmanı, kullanıcı davranışının oturum içindeki karar kalitesini ve sürtünme noktalarını gösterir."
        actions={[
          'Kabul yüksek ama pişirme düşük oturumlarda öneri sonrası adımı sadeleştir.',
          'Düşük örneklemli session sinyallerini toplu trend ile birlikte değerlendir.',
          'Session bazlı başarı örüntülerini öneri sıralamasına geri besle.'
        ]}
        anomalies={summary.anomalies}
        priority={summary.priority}
        confidence={summary.confidence}
        sampleSize={summary.sample}
        expectedOutcome="Session bazlı optimizasyon ile kabul->pişirme dönüşümünde +2 ila +6 puan hedeflenir."
      />

      <DrawerFooterActions onClose={onClose} onExport={handleExport} />
    </div>
  );
}
